var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div dias-cloak=\"vm.loading\" cloak-msg=\"'Organisationsdaten werden geladen'\" cloak-size=\"'sm'\"><div ng-repeat=\"typ in vm.foerderorgTypen\" ng-if=\"!vm.loading\"><div ng-if=\"typ.selected &amp;&amp; ($index === 0 || vm.foerderorgTypen[$index - 1].selected)\"><label class=\"font-weight-bold\">{{ typ.bez }}<p class=\"form-control-static\">{{ typ.selected.o_name }}</p></label></div></div></div>");;return buf.join("");
}